import { type ConnectedProps, connect } from 'react-redux';
import { type ModalContentProps, ModalLayout } from '@/core/features/modal';
import { acceptModal, cancelModal } from '@/slices/demo';

type Props = ModalContentProps &
  ConnectedProps<typeof connector> & {
    modalData: {
      id: string;
    };
  };

const DemoModal = ({
  closeModal,
  modalData: { id },
  acceptModal,
  cancelModal,
}: Props) => {
  const handleAccept = () => {
    acceptModal({ id });
  };

  const handleCancel = () => {
    cancelModal({ id });
  };

  return (
    <ModalLayout
      closeModal={closeModal}
      title="Demo Modal"
      onAccept={handleAccept}
      onCancel={handleCancel}
    >
      Demo ID: {id}
    </ModalLayout>
  );
};

const connector = connect(null, {
  acceptModal,
  cancelModal,
});

export default connector(DemoModal);
